import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import TutorLayout from "../Layouts/TutorLayout";
const PrivateRoute = () => {
    const token = localStorage.getItem("token");
   // console.log("PrivateRoute rendered");
    
    // If token exists, render child routes; otherwise, redirect to login
    return token ? <TutorLayout /> : <Navigate to="/login" />;
};

export default PrivateRoute;
